
import { Courier } from '@/services/types';
import { mockCouriers } from '@/services/mockData';

export const calculatePaymentCounts = (paymentsData: any[]) => {
  return paymentsData.reduce((acc: Record<string, number>, payment: { courier_id: string }) => {
    acc[payment.courier_id] = (acc[payment.courier_id] || 0) + 1;
    return acc;
  }, {});
};

export const formatCourierData = (courier: any): Courier => ({
  id: courier.id || '',
  name: courier.name || 'Без имени',
  email: courier.email || null,
  phone: courier.phone || null,
  status: ['active', 'inactive'].includes(courier.status) ? courier.status : 'inactive',
  totalRentals: typeof courier.totalrentals === 'number' ? courier.totalrentals : 0,
  registeredAt: courier.created_at || '',
  registrationDate: courier.created_at || new Date().toISOString(), // Добавляем registrationDate
  avatar: courier.avatar || null,
  deal_number: courier.deal_number || undefined,
  tariff: courier.tariff || undefined,
  amo_deal_id: courier.amo_deal_id || undefined,
  amo_contact_id: courier.amo_contact_id || undefined,
  telegram_id: courier.telegram_id || undefined,
  avito_id: courier.avito_id || undefined,
  vk_id: courier.vk_id || undefined,
  passport_number: courier.passport_number || undefined,
  registration_address: courier.registration_address || undefined,
  rental_start_ts: courier.rental_start_ts || undefined,
  rental_end_ts: courier.rental_end_ts || undefined,
  rental_end_human: courier.rental_end_human || undefined,
  last_payment_date: courier.last_payment_date || undefined,
  comments: courier.comments || undefined,
  has_paid: typeof courier.has_paid === 'boolean' ? courier.has_paid : undefined,
  paymentCount: 0
});

export const filterCouriers = (courierData: Courier, filterStatus: string | null) => {
  switch (filterStatus) {
    case 'multiple-payments':
      return courierData.paymentCount && courierData.paymentCount > 1 ? courierData : null;
    case 'paid':
      return courierData.has_paid ? courierData : null;
    case 'delayed':
      return !courierData.has_paid ? courierData : null;
    case 'active':
      return courierData.status === 'active' ? courierData : null;
    case 'inactive':
      return courierData.status === 'inactive' ? courierData : null;
    case 'telegram':
      return courierData.telegram_id ? courierData : null;
    case 'avito':
      return courierData.avito_id ? courierData : null;
    case 'phone':
      return (!courierData.telegram_id && !courierData.avito_id && !courierData.vk_id && courierData.phone) ? courierData : null;
    default:
      return courierData;
  }
};
